<template>
  <div style="padding-top: 3em;">
    <form autocomplete="off" method="POST" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.id)"
      @change="form.errors.clear($event.target.id)">
      <input type="hidden" name="_token" :value="csrf">
      <input type="hidden" v-model="form">

      <ctrInput v-model="form.firstname" id="firstname" label="First Name *" :error="form.errors.get('firstname')"
        placeholder="Please enter your first name"></ctrInput>
      <ctrInput v-model="form.lastname" id="lastname" label="Last Name" :error="form.errors.get('lastname')"
        placeholder="Please enter your last name"></ctrInput>
      <ctrInput v-model="form.emailaddress" id="emailaddress" label="Email" :error="form.errors.get('emailaddress')"
        placeholder="Please enter your email"></ctrInput>

      <ctrInput v-model="form.contactnumber" id="contactnumber" label="Contact Number"
        :error="form.errors.get('contactnumber')" placeholder="Please enter your contact number"></ctrInput>
      <ctrInput v-model="form.address" id="address" label="Address" :error="form.errors.get('address')"
        placeholder="Please enter your address"></ctrInput>


      <ctrCheckboxGroup v-model="form.binType" id="binType" name="binType" label="Bin Type"
        :error="form.errors.get('binType')" placeholder="Blue" options="['Blue','Green']">
      </ctrCheckboxGroup>


      <ctrInput v-model="form.repairType" id="repairType" label="Repair Type" :error="form.errors.get('repairType')"
        placeholder="Please enter your repair type"></ctrInput>

      <div class="notification">
        <ctrCheckbox v-model="form.binPlacement" id="binPlacement" label="Agreement"
          :error="form.errors.get('binPlacement')" placeholder="Please agree"></ctrCheckbox>
      </div>

      <div class="control">
        <button class="button is-primary" :disabled="form.errors.any() || form.binPlacement == false">Create</button>
      </div>


    </form>
  </div>
</template>
<script>
  import ctrInput from "./elements/Input.vue";
  import ctrCheckbox from "./elements/Checkbox.vue";
  import ctrCheckboxGroup from "./elements/CheckboxGroup.vue";
  import Form from '../utilities/Form';

  export default {
  components: {
    ctrInput, ctrCheckbox, ctrCheckboxGroup
  },
  props: {
    loadform: {}
  },
  data() {
    return {
      form: new Form ({ 
        firstname: '',
        lastname: '',
        emailaddress: '',
        contactnumber: '',
        address: '',
        binType: '',
        repairType: '',
        binPlacement: false,
      }),
      csrf: "",
    }
  },
  mounted() {
    this.csrf = window.laravel.csrfToken;
  },
  methods: {
    test() {
      alert('ljfhdjkfhd');
    },
    onSubmit() {
      this.form
        .post('/onlineform/showform/' + this.loadform)
        .then( data => console.log(data) )
        .catch(
          errors => 
          // this.form.errors = error.errors
          // error => this.errors = error.errors.errors
          // error =>  
          // this.errors = error.response.data
          console.log(errors)
          )
    },
    onSuccess(response) {
    }
  }

}
</script>


// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/form/Generate.vue